import React from 'react';
import { useThemeMode } from '../theme/ThemeProvider';
import Header from './Header';

const MainLayout = ({ children, showHomeButton = true, hideUserActions = false, hideHeader = false }) => {
  const { mode } = useThemeMode();
  const isDark = mode === 'dark';

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
      }}
    >
      {/* Background pseudo-element replacement */}
      <div
        style={{
          position: 'absolute',
          zIndex: -1,
          inset: 0,
          backgroundImage: isDark
            ? 'radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))'
            : 'radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))',
          backgroundRepeat: 'no-repeat',
        }}
      />
      {!hideHeader && <Header showHomeButton={showHomeButton} hideUserActions={hideUserActions} />}
      <main
        style={{
          flexGrow: 1,
          overflow: 'auto',
          paddingTop: hideHeader ? 32 : 72,
          paddingLeft: 16,
          paddingRight: 16,
          paddingBottom: 32,
          minHeight: '100vh',
          color: isDark ? 'rgba(255, 255, 255, 0.85)' : 'rgba(0, 0, 0, 0.88)',
        }}
      >
        {children}
      </main>
    </div>
  );
};

export default MainLayout;
